import styles from './Empty.module.scss';

const Empty = () => {
  return (
    <div className={styles.Empty}>
      <p>
        Введите артикул 📦 продукта, 🛠️ запчасти, 🧰 аксессуара или название в
        🔍 поисковой строке и выберите параметры в фильтрах, чтобы найти нужную
        запчасть
      </p>
    </div>
  );
};

export default Empty;
